module.exports = __webpack_public_path__ + "static/media/ham_village.e3164923.png";